// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"249":"7fe62e1d","442":"3f116950","464":"b521af58","689":"ae0e10b3","727":"441cf596","995":"2810b236"}[chunkId] + ".chunk.css";
};